<template>
  <contact-info-panel
    is-conversation-sidebar
    :contact="contact || {}"
    :conversation-id="conversationId"
    :inbox-id="inboxId"
    :on-close="onToggle"
    :open-source="openSource"
    :show-close-button="true"
    :show-avatar="true"
    :is-modal-view="false"
    @note-content-changed="$emit('note-content-changed', $event)"
  />
</template>

<script>
import ContactInfoPanel from 'dashboard/routes/dashboard/contacts/components/ContactInfoPanel.vue';

export default {
  name: 'ContactPanel',
  components: {
    ContactInfoPanel,
  },
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
    onToggle: {
      type: Function,
      default: () => {},
    },
    openSource: {
      type: String,
      default: 'contact_header',
      validator: value => ['contact_header', 'macros_button'].includes(value),
    },
    /** Optional: profile contact when ConversationBox is embedded on contact page. */
    contact: {
      type: Object,
      default: null,
    },
  },
};
</script>
